import React, { useState } from 'react';

interface Props {
  email: string;
  inviteUrl: string;
  onClose: () => void;
}

/**
 * Shown after creating/resending an invitation when the server cannot
 * deliver it by email (SMTP not configured, or app runs on localhost).
 * Admin can copy the link and send it manually.
 */
const InviteLinkModal: React.FC<Props> = ({ email, inviteUrl, onClose }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(inviteUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      // Clipboard access denied — user can still select manually.
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-full max-w-md mx-4">
        <h2 className="text-lg font-semibold text-gray-800 mb-2">Приглашение создано</h2>
        <p className="text-sm text-gray-600 mb-4">
          Email-рассылка пока не настроена. Отправьте ссылку пользователю{' '}
          <span className="font-medium text-gray-800">{email}</span> вручную:
        </p>

        <div className="bg-gray-100 border border-gray-200 rounded-md px-3 py-2 text-sm text-gray-800 break-all mb-4">
          {inviteUrl}
        </div>

        <div className="flex gap-2">
          <button
            onClick={handleCopy}
            className="flex-1 py-2 px-4 bg-blue-600 text-white rounded-md hover:bg-blue-700 text-sm"
          >
            {copied ? 'Скопировано' : 'Скопировать'}
          </button>
          <button
            onClick={onClose}
            className="flex-1 py-2 px-4 border border-gray-300 rounded-md hover:bg-gray-50 text-sm"
          >
            Закрыть
          </button>
        </div>
      </div>
    </div>
  );
};

export default InviteLinkModal;
